'use es6';

import { Record, List } from 'immutable';
export default Record({
  categories: List(),
  completeForUser: undefined,
  content: List(),
  description: undefined,
  hasError: false,
  id: undefined,
  isRequesting: false,
  graded: false,
  inactiveRedirectUrl: undefined,
  lastValidResult: 0,
  learningMaterials: List(),
  name: undefined,
  productAccess: List(),
  products: List(),
  professors: List(),
  recentError: undefined,
  slidesUrl: undefined,
  transcriptUrl: undefined,
  teaser: undefined,
  topics: List(),
  language: null,
  visibility: undefined
}, 'Lesson');